module.exports = __webpack_public_path__ + "static/media/CBSE2013.bb0768ca.jpg";